import React, { useState } from 'react';
import { FaMapMarkerAlt, FaGlobeAmericas } from 'react-icons/fa';  // Import specific icons
import { MdLocationOn } from 'react-icons/md';  // Example of Material Design icon

const cityCategories = [
    { 
      category: 'Nearby Cities', 
      cities: ['Ajmer', 'Alwar', 'Behror', 'Sikar', 'Dausa', 'Tonk', 'Bharatpur', 'Kishangarh', 'Niwai', 'Churu']
    },
    { 
      category: 'Popular Cities', 
      cities: ['Mumbai', 'Delhi', 'Bangalore', 'Chennai', 'Kolkata', 'Pune', 'Hyderabad', 'Ahmedabad', 'Jaipur', 'Chandigarh']
    },
    { 
      category: 'Other Cities', 
      cities: ['Lucknow', 'Agra', 'Surat', 'Indore', 'Vadodara', 'Patna', 'Nagpur', 'Kanpur', 'Nagaland', 'Udaipur', 'Jodhpur', 'Amritsar', 'Ranchi', 'Bhubaneswar', 'Bikaner', 'Ajmer']
    }
  ];
  

const countries = [
    { name: 'NRI Home', flag: 'https://upload.wikimedia.org/wikipedia/commons/a/a4/Flag_of_India.svg', code: 'IN' },
    { name: 'Canada', flag: 'https://upload.wikimedia.org/wikipedia/commons/c/cf/Flag_of_Canada.svg', code: 'CA' },
    { name: 'Australia', flag: 'https://upload.wikimedia.org/wikipedia/commons/b/b9/Flag_of_Australia.svg', code: 'AU' },
    { name: 'Singapore', flag: 'https://upload.wikimedia.org/wikipedia/commons/4/48/Flag_of_Singapore.svg', code: 'SG' }
];

const CityList = ({onCitySelect}) => {
    const [selectedCountry, setSelectedCountry] = useState(null);

    const handleSelectCountry = (countryCode) => {
        setSelectedCountry(countryCode);
    };

    return (
        <div className="px-4 py-4 z-50 shadow-sm border rounded flex w-[1000px]">
            <div className='w-[75%]'>
                <h2 className="text-lg font-normal mb-1 uppercase mt-1 flex items-center">
                    <FaMapMarkerAlt className="mr-2" />India
                </h2>
                {cityCategories.map((category, index) => (
                    <div key={index} className="mb-2">
                        <h3 className="text-[16px] font-semibold">{category.category}</h3>
                        <ul className="grid grid-cols-5 ">
                            {category.cities.map((city, idx) => (
                                <li 
                                key={idx}
                                onClick={() => onCitySelect(city)} // Send selected city to parent
                                className="text-sm hover:text-red-500 bg-white cursor-pointer font-normal">{city}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
            <div className='border-l border-gray-200'></div>
            <div className='w-[25%]' style={{ paddingLeft: '20px' }}>
                <h1 className='mb-10 mt-2 flex items-center font-normal'>
                    <FaGlobeAmericas className="mr-2" />International
                </h1>
                <div className="flex flex-col font-normal text-sm">
                    {countries.map((country) => (
                        <a
                            href="#"
                            onClick={() => handleSelectCountry(country.code)}
                            key={country.code}
                            className={`hover:text-red-500 flex items-center p-2 rounded ${
                                selectedCountry === country.code ? 'bg-gray-200' : ''
                            }`}
                        >
                            <img
                                src={country.flag}
                                alt={country.name}
                                className="mr-2 w-[20px] h-[15px]"
                            />
                            {country.name}
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CityList;
